import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { checkTestStepsUpdatedOrNot, updatedTheTestCaseScriptsInExecution } from '../../../../modules/executions';

const UpdateTestScriptsAlert = ({
  execution,
  data,
  fetchSelectedExecutionDetails,
}) => {
  const [isTestScriptUpdated, setIsTestScriptUpdated] = useState(true);
  const checkForUpdatedTestScripts = async () => {
    try {
      const response = await checkTestStepsUpdatedOrNot(data?.id, execution?.id);
      setIsTestScriptUpdated(response?.is_test_steps_updated);
    } catch (error) {
      console.log(error);
    }
  };

  const updateOutdatedTestScripts = async () => {
    try {
      await updatedTheTestCaseScriptsInExecution(data?.id, execution?.id);
      setIsTestScriptUpdated(true);
      fetchSelectedExecutionDetails(execution?.id);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (execution?.id && data?.id)
      checkForUpdatedTestScripts();
  }, [execution, data]);

  if (isTestScriptUpdated) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      className="d-flex justify-content-between align-items-center">
      <span>
        This test script is outdated because the test case has been changed.
      </span>
      <Button variant="primary" size="sm" onClick={updateOutdatedTestScripts}>
        Update
      </Button>
    </Alert>
  );
};

export default UpdateTestScriptsAlert;
